export default __webpack_public_path__ + "navigation-examples-basic-thumbnail-960-c179586a4cca2b07112cdc533da72616.webp";